/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-03 09:00:04
 */

import UserConfig from '../userConfig';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import UserConfigApi, { UserConfigDOI } from '../api/userConfigApi';
import _ from 'lodash';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import Input from 'src/types/iview/Input';
import EnumEntity from 'src/enums/enumEntity';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumUserStatus from 'src/enums/enumUserStatus';
import EnumSex from 'src/enums/enumSex';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import alertUserOperateModal from '../userOperateModal';
import EnumOperates from 'src/enums/enumOperates';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import alertAddStationModal from '../addStationModal';

export default class UserConfigService extends ListPageService {
    ctx: UserConfig;

    constructor(ctx: UserConfig) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '姓名',
                field: 'real_name',
                minWidth: 120,
            },
            {
                headerName: '所属组织',
                field: 'organization',
                minWidth: 160,
            },
            {
                headerName: '性别',
                field: 'sex',
                minWidth: 100,
                cellRenderer(params) {
                    let data: UserConfigDOI.RowDataI = params.data;
                    return EnumSex.findId(data.sex).getName();
                },
            },
            {
                headerName: '手机号',
                field: 'mobile',
                minWidth: 140,
            },
            {
                headerName: '角色',
                field: 'role_name',
                minWidth: 140,
            },
            {
                headerName: '状态',
                field: 'status',
                minWidth: 140,
                cellRenderer(params) {
                    let data: UserConfigDOI.RowDataI = params.data;
                    return EnumUserStatus.findId(data.status).getName();
                },
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 160,
                maxWidth: 160,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '选择站点',
                        hide() {
                            return t.ctx.$route.path === '/sass/systemConfig/userConfig/index'
                        },
                        async click(params) {
                            let data: UserConfigDOI.RowDataI = params.data;
                            alertAddStationModal(data.id, data.organization_id);
                        },
                    },
                    {
                        text: '修改',
                        async click(params) {
                            let data: UserConfigDOI.RowDataI = params.data;
                            let res = await alertUserOperateModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        disabled(params) {
                            let data: UserConfigDOI.RowDataI = params.data;
                            return data.role_id ===1;
                        },
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: UserConfigDOI.RowDataI = params.data;
                            await t.delete([data.id]);
                        },
                    },
                ],
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: EntitySelect,
                label: '所属组织：',
                field: 'organization',
                props: { value: null, type: EnumEntity.Organization.getId() },
            },

            {
                component: CommonSelect,
                label: '状态：',
                field: 'status',
                props: { value: null, dataSource: EnumUserStatus.getList() },
            },
            {
                component: Input,
                label: '',
                field: 'keyword',
                labelWidth: 20,
                props: { value: '', placeholder: '用户名/姓名/手机号' },
            },
        ];
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertUserOperateModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            },
        ];
    }

    async delete(ids: number[]) {
        let { code } = await UserConfigApi.delete(ids[0]);
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<UserConfigDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await UserConfigApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
